import { ref } from 'vue';
import { IPathConfiguration } from '../../pages/deliveryIssues/models/interfaces/IPathConfigurationProps';
import { useAnalytics } from './useAnalytics';
import { useTags } from './useTags';
import { useAppStorage } from './useAppStorage';
import { usePathUtils } from './usePathUtils';
import { TagsType } from '../models/types/TagsType';

export const useMetrics = (pageName: string) => {
  const arrayMetrics = ref<string | string[]>(JSON.parse(useAppStorage('getStorageItem', 'arrayMetrics') || '[]'));

  const metricHandler = (source: string = 'online', tag: TagsType = 'DELIVERY_ISSUES') => {
    useAnalytics('sendClickAnalytics', {
      pageName,
      linkName: `${useTags('getTag', tag)}_${source}`,
    });
  };

  const prepareAndSendMetric = (namePath: string, stepValue: number) => {
    const configuration: IPathConfiguration = usePathUtils('getPathConfiguration', { namePath });
    if (configuration.metrics) {
      arrayMetrics.value = configuration.metrics;
      useAppStorage('setStorageItem', 'arrayMetrics', JSON.stringify(arrayMetrics.value));
    }
    const metric = arrayMetrics.value[stepValue - 1] || 'online';
    if (metric) metricHandler(metric);
  };

  return { metricHandler, prepareAndSendMetric, arrayMetrics };
}
